import React from 'react';

//Utils
import { MESSAGES } from '~/utils/message';

// MUI Components
import OlcButton from '~/components/General/OlcButton';
import EmptyStateCard from '~/components/General/EmptyStateCard';

// Icons
import { NoCampaignsCIcon } from '~/assets/images';

const NoCampaignsScreen = ({ onCreateCampaign }) => {
  return (
    <>
      <div className="olcEmptyStateToolbar">
        <OlcButton variant="primary" onClick={onCreateCampaign}>
          {MESSAGES.COMPAIGNS.NO_CAMPAIGNS_SCREEN.CREATE_BUTTON_NEW}
        </OlcButton>
      </div>
      <EmptyStateCard
        icon={NoCampaignsCIcon}
        iconAlt="no-campaigns"
        title={MESSAGES.COMPAIGNS.NO_CAMPAIGNS_SCREEN.TITLE_NEW}
        description={MESSAGES.COMPAIGNS.NO_CAMPAIGNS_SCREEN.MESSAGE}
        learnMoreLabel={MESSAGES.COMPAIGNS.NO_CAMPAIGNS_SCREEN.LEARN_MORE_BUTTON}
      />
    </>
  );
};

export default NoCampaignsScreen;
